import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import { 
	sendNewEmailMessage, 
} from '../message/thunk';

export const initialState = {
	itemMessageList: [],
	itemMessageDetail: null,
	isMessageLoading: false,
	isMessageSuccess: false,

	messageDetail: [],
	messageListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const MessageSlice = createSlice({
	name: 'Message',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
	
		builder.addCase(sendNewEmailMessage.fulfilled, (state, action) => {
			state.itemMessageList.push(action.payload);
			state.messageDetail.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(sendNewEmailMessage.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(sendNewEmailMessage.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});
	},
});

export const { setRequireCloseModal } = MessageSlice.actions;

export default MessageSlice.reducer;
